import { Home } from "@/pages/home";
import BaseV2 from "@/layout/v2/base";
import { PageTagihanV2, PageTagihanDetailV2, PageHistoryTagihanV2 } from "@/pages/InfoPelanggan/v2";
import { RegistrasiPelanggan } from "@/pages/RegistrasiPelanggan";
import { Whistleblower } from "@/pages/Whistleblower";
import { WhistleblowerSystemPage } from "@/pages/WhistleblowerSystem";

const { createBrowserRouter } = require("react-router-dom");
const { Midleware, Base, Auth, NotFound } = require("@/layout");
const { AuthRouter, TagihanRouter } = require("./public");
const { TagihanRouterV2 } = require("./public/v2");

export const routerApp = createBrowserRouter([
    {
        path: '/',
        element: <Midleware isProtected={false} render={<BaseV2 />}/>,
        children: [
            {
                index: true,
                element: <Home />
            },
            {
                path: 'info-tagihan',
                element: <PageTagihanV2 />
            },
            {
                path: 'info-tagihan/:id',
                element: <PageTagihanDetailV2 />
            },
            {
                path: 'history-tagihan',
                element: <PageHistoryTagihanV2 />
            },
            {
                path: 'registrasi-pelanggan',
                element: <RegistrasiPelanggan />
            },
            {
                path: 'pengaduan',
                element: <Whistleblower />
            },
            {
                path: 'whistleblower',
                element: <WhistleblowerSystemPage />
            },
            ...TagihanRouterV2
        ]
    },
    {
        path: '/old',
        element: <Midleware isProtected={false} render={<Base />}/>,
        children: [
            ...TagihanRouter
        ]
    },
    {
        path: 'auth',
        element: <Midleware isProtected={false} render={<Auth />}/>,
        children: [
            // Public Routes
            ...AuthRouter,
        ]
    },
    {
        path: "*",
        element: <NotFound />,
    },
],
{
    basename: process.env.REACT_APP_BASENAME || '/'
}

)
